import React, { useEffect, useState } from "react";
import { Button, Card, Col, Input, Label, Row } from "reactstrap";
import { motion, AnimatePresence } from "framer-motion";
import {
  getCalificacionContactoforCampaign,
  getCampaignFullList,
  getDescripcionCalificacion,
  postLeadsStatusChange,
  putGuardarGestion
} from "../../../helpers/backend";
import { useParams } from "react-router-dom";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import { FiX, FiCalendar, FiClock, FiSave } from "react-icons/fi";

const ManagementCreate = ({
  updateManagementOpen,
  selectedContact,
  onSubmitStatus,
  selectedCampaign,
  isLead,
  leadId,
  leadData,
  refresh
}) => {
  const contactId = useParams().id;
  const [alert, setAlert] = useState(false);
  const [status, setStatus] = useState(false);
  const [message, setMessage] = useState("");
  const [campaignId, setCampaignId] = useState(null);
  const [gestionId, setGestionId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [campaignData, setCampaignData] = useState([]);

  // Obtener campañas completas solo si selectedCampaign está vacío
  const getCampaignData = async () => {
    if (!selectedCampaign || selectedCampaign.length === 0) {
      const response = await getCampaignFullList();
      setCampaignData(response.data);
    }
  };

  const [calificacionList, setCalificacionList] = useState([]);
  const getCalificacionData = async (id) => {
    const response = await getCalificacionContactoforCampaign(id);
    const data = response.data;
    setCalificacionList(data);
  };

  const [descripcionList, setDescripcionList] = useState({});
  const getDescripcionData = async (id) => {
    const response = await getDescripcionCalificacion(id);
    const data = response.data;
    setDescripcionList(data);
  };
  const getSelectedCampaignValue = () => {
    if (!campaignId) return null;

    // Buscar en selectedCampaign primero
    if (selectedCampaign && selectedCampaign.length > 0) {
      const found = selectedCampaign.find((c) => c.id === campaignId);
      if (found) {
        return { label: found.name, value: found.id };
      }
    }

    // Si no está en selectedCampaign, buscar en campaignData
    const found = campaignData.find((c) => c.id === campaignId);
    return found ? { label: found.name, value: found.id } : null;
  };
  useEffect(() => {
    // Si selectedCampaign tiene exactamente 1 elemento, usar ese ID directamente
    if (selectedCampaign && selectedCampaign.length === 1) {
      const singleCampaignId = selectedCampaign[0].id;
      setCampaignId(singleCampaignId);
      setFormData((prev) => ({
        ...prev,
        campaign: singleCampaignId
      }));
      getCalificacionData(singleCampaignId);
    }
    getCampaignData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCampaign]);

  const [formData, setFormData] = useState({
    calificacion: "",
    descripcion: "",
    observaciones: "",
    fecha_proximo_contacto: null,
    hora_proximo_contacto: null,
    contacto: contactId ? contactId : selectedContact,
    campaign: campaignId,
    is_leads: isLead,
    lead: null
  });

  useEffect(() => {
    if (campaignId) {
      getCalificacionData(campaignId);
    }
  }, [campaignId]);

  useEffect(() => {
    if (formData.calificacion) {
      getDescripcionData(formData.calificacion);
    }
  }, [formData.calificacion]);

  const onSubmit = async () => {
    setIsSubmitting(true);
    try {
      const response = await putGuardarGestion(
        contactId ? contactId : selectedContact,
        formData
      );
      setGestionId(response.data.gestion.id);
      setStatus(response.status);
      setAlert(true);
      setMessage(response.data.message);
      onSubmitStatus(true);
    } catch (error) {
      setStatus(error.response?.status || 500);
      setMessage(error.response?.data?.message || "Error desconocido");
      setAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleManagementButtonClick = () => {
    updateManagementOpen(false);
  };

  const FinalizarGestion = async () => {
    await postLeadsStatusChange(leadId, {
      accion: "FINALIZAR",
      gestion: gestionId
    });
  };

  // Animaciones
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        ease: "easeOut",
        duration: 0.3
      }
    }
  };

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "44px",
      borderRadius: "8px",
      border: "1px solid #e2e8f0",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#cbd5e0"
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#0e685f" : "white",
      color: state.isSelected ? "white" : "#1a202c",
      "&:hover": {
        backgroundColor: "#f7fafc"
      }
    })
  };
  console.log(selectedCampaign);
  return (
    <>
      <AnimatePresence>
        {status === 200 && alert && (
          <SweetAlert
            title="¡Éxito!"
            success
            timeout={2000}
            showConfirm={false}
            onConfirm={() => {
              FinalizarGestion();
              refresh();
            }}
          >
            {message}
          </SweetAlert>
        )}
        {status !== 200 && alert && (
          <SweetAlert
            title="Error"
            error
            timeout={2000}
            showConfirm={false}
            onConfirm={() => {
              setAlert(false);
            }}
          >
            {message}
          </SweetAlert>
        )}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
      >
        <Card
          className="border-0 shadow-sm"
          style={{ borderTop: "4px solid #0e685f" }}
        >
          <div className="management-container p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="m-0 text-gray-800 font-weight-bold">
                Tipificación
              </h4>
              <button
                onClick={handleManagementButtonClick}
                className="btn btn-sm btn-icon btn-light rounded-circle"
              >
                <FiX size={18} />
              </button>
            </div>

            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              {/* Select para Negocio */}
              {leadData &&
                leadData.length > 0 &&
                leadData.some((item) => item.negocio !== null) && (
                  <motion.div variants={itemVariants}>
                    <Row className="justify-content-center mb-3">
                      <Col lg={10}>
                        <Label
                          for="lead"
                          className="form-label text-sm font-weight-medium text-gray-700"
                        >
                          Negocio
                        </Label>
                        <Select
                          id="lead"
                          name="lead"
                          placeholder="Seleccione un negocio"
                          onChange={(item) =>
                            setFormData({
                              ...formData,
                              lead: item ? item.value : null
                            })
                          }
                          styles={selectStyles}
                          options={leadData
                            .filter((item) => item.negocio !== null)
                            .map((item) => ({
                              label: item.negocio,
                              value: item.id
                            }))}
                          menuPosition="fixed"
                          isClearable
                        />
                      </Col>
                    </Row>
                  </motion.div>
                )}

              {/* Select para Campaña - Solo se muestra si hay más de una campaña o ninguna */}
              {(selectedCampaign && selectedCampaign.length > 1) ||
              !selectedCampaign ||
              selectedCampaign.length === 0 ? (
                <motion.div variants={itemVariants}>
                  <Row className="justify-content-center mb-3">
                    <Col lg={10}>
                      <Label
                        for="campaign"
                        className="form-label text-sm font-weight-medium text-gray-700"
                      >
                        Campaña
                      </Label>
                      <Select
                        styles={selectStyles}
                        options={
                          selectedCampaign && selectedCampaign.length > 0
                            ? selectedCampaign.map((item) => ({
                                label: item.name,
                                value: item.id
                              }))
                            : campaignData.map((item) => ({
                                label: item.name,
                                value: item.id
                              }))
                        }
                        onChange={(item) => {
                          setCampaignId(item.value);
                          setFormData({
                            ...formData,
                            campaign: item.value
                          });
                          getCalificacionData(item.value);
                        }}
                        value={getSelectedCampaignValue()}
                        placeholder={"Seleccione una campaña"}
                        isMulti={false}
                        menuPosition="fixed"
                      />
                    </Col>
                  </Row>
                </motion.div>
              ) : null}

              <motion.div variants={itemVariants}>
                <Row className="justify-content-center mb-3">
                  <Col lg={10}>
                    <Label
                      for="calificacion"
                      className="form-label text-sm font-weight-medium text-gray-700"
                    >
                      Resultados
                    </Label>
                    <Select
                      id="calificacion"
                      name="calificacion"
                      placeholder="Seleccione un resultado"
                      onChange={(item) =>
                        setFormData({
                          ...formData,
                          calificacion: item.value
                        })
                      }
                      styles={selectStyles}
                      options={
                        Array.isArray(calificacionList)
                          ? calificacionList.map((item) => ({
                              label: item.name,
                              value: item.id
                            }))
                          : []
                      }
                      menuPosition="fixed"
                    />
                  </Col>
                </Row>
              </motion.div>

              <motion.div variants={itemVariants}>
                <Row className="justify-content-center mb-3">
                  <Col lg={10}>
                    <Label
                      for="rol"
                      className="form-label text-sm font-weight-medium text-gray-700"
                    >
                      Calificación
                    </Label>
                    <Select
                      placeholder="Seleccione una calificación"
                      styles={selectStyles}
                      options={
                        Array.isArray(descripcionList)
                          ? descripcionList.map((item) => ({
                              label: item.name,
                              value: item.id
                            }))
                          : []
                      }
                      onChange={(item) =>
                        setFormData({
                          ...formData,
                          descripcion: item.value
                        })
                      }
                      menuPosition="fixed"
                    />
                  </Col>
                </Row>
              </motion.div>

              <motion.div variants={itemVariants}>
                <Row className="justify-content-center mb-3">
                  <Col lg={10}>
                    <Label
                      for="observaciones"
                      className="form-label text-sm font-weight-medium text-gray-700"
                    >
                      Observaciones
                    </Label>
                    <Input
                      id="observaciones"
                      name="observaciones"
                      type="textarea"
                      className="border rounded-lg p-3"
                      style={{ minHeight: "100px" }}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          observaciones: e.target.value
                        })
                      }
                    />
                  </Col>
                </Row>
              </motion.div>

              <motion.div variants={itemVariants}>
                <div className="bg-gray-100 p-3 rounded-lg mb-4">
                  <h6 className="text-gray-700 font-weight-medium mb-3 d-flex align-items-center">
                    <FiCalendar className="me-2" /> Próximo Contacto (Opcional)
                  </h6>

                  <Row className="g-3">
                    <Col md={6}>
                      <Label
                        for="date"
                        className="form-label text-sm font-weight-medium text-gray-700"
                      >
                        Fecha
                      </Label>
                      <div className="input-group">
                        <span className="input-group-text bg-white">
                          <FiCalendar />
                        </span>
                        <Input
                          id="date"
                          name="date"
                          type="date"
                          className="form-control"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              fecha_proximo_contacto: e.target.value
                            });
                          }}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <Label
                        for="time"
                        className="form-label text-sm font-weight-medium text-gray-700"
                      >
                        Hora
                      </Label>
                      <div className="input-group">
                        <span className="input-group-text bg-white">
                          <FiClock />
                        </span>
                        <Input
                          id="time"
                          name="time"
                          type="time"
                          className="form-control"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              hora_proximo_contacto: e.target.value
                            });
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="text-center mt-4">
                <Button
                  color="primary"
                  onClick={onSubmit}
                  disabled={isSubmitting}
                  className="px-5 py-2 rounded-lg d-inline-flex align-items-center"
                >
                  {isSubmitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Guardando...
                    </>
                  ) : (
                    <>
                      <FiSave className="me-2" /> Guardar Gestión
                    </>
                  )}
                </Button>
              </motion.div>
            </motion.div>
          </div>
        </Card>
      </motion.div>
    </>
  );
};

export default ManagementCreate;
